import { configurePanel } from '@grapes-agency/ui'

import classes from './Panel.module.scss'

export const Panel = configurePanel({ classes })
